export default __webpack_public_path__ + "static/media/breezy.8423e904.svg";